/* =========================================================



   AIHM CLINICS LANDING PAGE



   Shared JavaScript



   ========================================================= */







(function () {



  'use strict';











  /* =======================================================



     LOCATION CAROUSEL



     ======================================================= */







  function initAIHMLocationCarousel(root) {







    if (!root || root.dataset.aihmInitialized === 'true') {



      return;



    }







    root.dataset.aihmInitialized = 'true';







    const viewport = root.querySelector('.aihm-locations__viewport');



    const track = root.querySelector('.aihm-locations__track');







    const cards = Array.from(



      root.querySelectorAll('.aihm-location-card')



    );







    const dots = Array.from(



      root.querySelectorAll('.aihm-locations__dot')



    );







    const prev = root.querySelector(



      '.aihm-locations__arrow--prev'



    );







    const next = root.querySelector(



      '.aihm-locations__arrow--next'



    );







    if (!viewport || !track || !cards.length) {



      return;



    }







    let activeIndex = 0;



    let slideIndex = 0;











    /* -------------------------------------------------------



       Number of visible cards



       ------------------------------------------------------- */







    function visibleCards() {







      if (window.innerWidth <= 749) {



        return 2;



      }







      if (window.innerWidth <= 989) {



        return 3;



      }







      return 5;



    }











    /* -------------------------------------------------------



       Maximum slide position



       ------------------------------------------------------- */







    function maxSlide() {







      return Math.max(



        0,



        cards.length - visibleCards()



      );



    }











    /* -------------------------------------------------------



       Calculate distance between cards



       ------------------------------------------------------- */







    function cardStep() {







      if (cards.length < 2) {



        return cards[0].offsetWidth;



      }







      return (



        cards[1].offsetLeft -



        cards[0].offsetLeft



      );



    }











    /* -------------------------------------------------------



       Update desktop/tablet carousel position



       ------------------------------------------------------- */







    function updateTrack() {















      slideIndex = Math.max(



        0,



        Math.min(slideIndex, maxSlide())



      );







      track.style.transform =



        'translate3d(-' +



        (slideIndex * cardStep()) +



        'px, 0, 0)';



    }











    /* -------------------------------------------------------



       Activate location



       ------------------------------------------------------- */







    function activate(index, scrollMobile) {







      if (



        index < 0 ||



        index >= cards.length



      ) {



        return;



      }







      activeIndex = index;







      cards.forEach(function (card, cardIndex) {







        const active = cardIndex === index;







        card.classList.toggle(



          'is-active',



          active



        );







        card.setAttribute(



          'aria-pressed',



          active ? 'true' : 'false'



        );







      });











      dots.forEach(function (dot, dotIndex) {







        dot.classList.toggle(



          'is-active',



          dotIndex === index



        );







      });











      const location =



        cards[index].dataset.aihmLocation;











      /*



       * Important:



       * Future AIHM sections listen to this event.



       *



       * Patient Stories



       * Clinic Details



       * Gallery



       * Appointment Form



       */







      document.dispatchEvent(



        new CustomEvent(



          'aihm:location-change',



          {



            detail: {



              location: location,



              index: index



            }



          }



        )



      );



























document.addEventListener('aihm:appointment-open', function (event) {







  const modal = document.querySelector('[data-aihm-appointment-modal]');







  if (!modal) return;







  const clinicField = modal.querySelector('[data-aihm-selected-clinic]');



  const clinicSelect = modal.querySelector('[data-aihm-clinic-select]');







  const locationName =



    event.detail && event.detail.locationName



      ? event.detail.locationName



      : '';







  if (clinicField) {



    clinicField.value = locationName;



  }







  if (clinicSelect && locationName) {



    const normalizeLocation = function (value) {

      return String(value || '')

        .trim()

        .toLowerCase()

        .replace(/&/g, 'and')

        .replace(/[^a-z0-9]+/g, '-')

        .replace(/^-+|-+$/g, '');

    };



    const normalizedLocation = normalizeLocation(locationName);



    const option = Array.from(clinicSelect.options).find(function (opt) {



      return normalizeLocation(opt.value) === normalizedLocation;



    });







    if (option) {



      clinicSelect.value = option.value;



    }



  }







  modal.classList.add('is-open');



  modal.setAttribute('aria-hidden', 'false');



  document.body.classList.add('aihm-modal-open');







});



















































document.addEventListener('click', function (event) {







  const closeButton = event.target.closest('[data-aihm-appointment-close]');







  if (!closeButton) return;







  const modal = document.querySelector('[data-aihm-appointment-modal]');







  if (!modal) return;







  modal.classList.remove('is-open');



  modal.setAttribute('aria-hidden', 'true');



  document.body.classList.remove('aihm-modal-open');







});















































      /* Mobile: keep selected card visible */



      if (window.innerWidth <= 749 && scrollMobile) {



        if (index < slideIndex) {



          slideIndex = index;



        } else if (index >= slideIndex + visibleCards()) {



          slideIndex = index - visibleCards() + 1;



        }



        updateTrack();



      }







    }











    /* -------------------------------------------------------



       Card clicks



       ------------------------------------------------------- */







    cards.forEach(function (card, index) {







      card.addEventListener(



        'click',



        function () {







          activate(index, true);







          if (index < slideIndex) {







            slideIndex = index;







          } else if (



            index >=



            slideIndex + visibleCards()



          ) {







            slideIndex =



              index -



              visibleCards() +



              1;



          }







          updateTrack();



        }



      );







    });











    /* -------------------------------------------------------



       Pagination dots



       ------------------------------------------------------- */







    dots.forEach(function (dot, index) {







      dot.addEventListener(



        'click',



        function () {







          activate(index, false);







          slideIndex = Math.min(



            index,



            maxSlide()



          );







          updateTrack();



        }



      );







    });











    /* -------------------------------------------------------



       Previous arrow



       ------------------------------------------------------- */







    if (prev) {







      prev.addEventListener(



        'click',



        function () {







          slideIndex = Math.max(



            0,



            slideIndex - 1



          );







          updateTrack();



        }



      );







    }











    /* -------------------------------------------------------



       Next arrow



       ------------------------------------------------------- */







    if (next) {







      next.addEventListener(



        'click',



        function () {







          slideIndex = Math.min(



            maxSlide(),



            slideIndex + 1



          );







          updateTrack();



        }



      );







    }











    /* -------------------------------------------------------



       Mobile swipe support



       ------------------------------------------------------- */







    let touchStartX = 0;



    let touchStartY = 0;







    viewport.addEventListener('touchstart', function (event) {



      if (!event.touches.length) return;



      touchStartX = event.touches[0].clientX;



      touchStartY = event.touches[0].clientY;



    }, { passive: true });







    viewport.addEventListener('touchend', function (event) {



      if (!event.changedTouches.length || window.innerWidth > 749) return;







      const dx = event.changedTouches[0].clientX - touchStartX;



      const dy = event.changedTouches[0].clientY - touchStartY;







      if (Math.abs(dx) < 35 || Math.abs(dx) < Math.abs(dy)) return;







      if (dx < 0) {



        slideIndex = Math.min(maxSlide(), slideIndex + 1);



      } else {



        slideIndex = Math.max(0, slideIndex - 1);



      }







      updateTrack();



    }, { passive: true });











    /* -------------------------------------------------------



       Resize handling



       ------------------------------------------------------- */







    let resizeTimer;







    window.addEventListener(



      'resize',



      function () {







        clearTimeout(resizeTimer);







        resizeTimer = setTimeout(



          updateTrack,



          100



        );







      }



    );











    /* -------------------------------------------------------



       Initial state



       ------------------------------------------------------- */







    activate(activeIndex, false);







    requestAnimationFrame(



      updateTrack



    );



  }











  /* =======================================================



     INITIALIZE ALL AIHM CAROUSELS



     ======================================================= */







  function initAllAIHMCarousels(scope) {







    const context =



      scope &&



      typeof scope.querySelectorAll === 'function'



        ? scope



        : document;







    const carousels =



      context.querySelectorAll(



        '[data-aihm-location-carousel]'



      );







    carousels.forEach(



      initAIHMLocationCarousel



    );



  }











  /* =======================================================



     NORMAL PAGE LOAD



     ======================================================= */







  if (document.readyState === 'loading') {







    document.addEventListener(



      'DOMContentLoaded',



      function () {



        initAllAIHMCarousels(document);



      }



    );







  } else {







    initAllAIHMCarousels(document);







  }











  /* =======================================================



     SHOPIFY THEME EDITOR SUPPORT



     ======================================================= */







  document.addEventListener(



    'shopify:section:load',



    function (event) {







      initAllAIHMCarousels(



        event.target



      );







    }



  );







})();







/* =============== AIHM CLINICS LANDING PAGE Shared JavaScript END ========= */































/* =========================================================



   AIHM CLINIC CONTENT



   Connect Location Carousel with Clinic Content



   ========================================================= */







(function () {



  'use strict';







  let currentAIHMLocation = null;











  /* -------------------------------------------------------



     Normalize location



     Same format as Shopify handleize output



     ------------------------------------------------------- */







  function normalizeAIHMLocation(value) {







    return String(value || '')



      .trim()



      .toLowerCase()



      .replace(/&/g, 'and')



      .replace(/[^a-z0-9]+/g, '-')



      .replace(/^-+|-+$/g, '');







  }











  /* -------------------------------------------------------



     Switch clinic content



     ------------------------------------------------------- */







  function showAIHMClinic(location) {







    if (!location) {



      return;



    }







    const normalizedLocation =



      normalizeAIHMLocation(location);







    currentAIHMLocation =



      normalizedLocation;







    const sections =



      document.querySelectorAll(



        '[data-aihm-clinic-content]'



      );







    sections.forEach(function (section) {







      const panels =



        Array.from(



          section.querySelectorAll(



            '[data-aihm-clinic]'



          )



        );







      if (!panels.length) {



        return;



      }







      let matchedPanel = null;











      panels.forEach(function (panel) {







        const panelLocation =



          normalizeAIHMLocation(



            panel.dataset.aihmClinic



          );







        const isMatch =



          panelLocation === normalizedLocation;







        panel.hidden = !isMatch;







        panel.classList.toggle(



          'is-active',



          isMatch



        );







        panel.setAttribute(



          'aria-hidden',



          isMatch ? 'false' : 'true'



        );







        if (isMatch) {



          matchedPanel = panel;



        }







      });











      /*



       * If there is no matching block,



       * do not show incorrect clinic data.



       */







      if (!matchedPanel) {







        panels.forEach(function (panel) {







          panel.hidden = true;







          panel.classList.remove(



            'is-active'



          );







          panel.setAttribute(



            'aria-hidden',



            'true'



          );







        });







      }







    });







  }











  /* -------------------------------------------------------



     Listen for location carousel



     ------------------------------------------------------- */







  document.addEventListener(



    'aihm:location-change',



    function (event) {







      if (



        !event.detail ||



        !event.detail.location



      ) {



        return;



      }







      showAIHMClinic(



        event.detail.location



      );







    }



  );











  /* -------------------------------------------------------



     Get currently selected location



     Useful after Shopify section reload



     ------------------------------------------------------- */







  function getSelectedAIHMLocation() {







    const activeCard =



      document.querySelector(



        '.aihm-location-card.is-active'



      );







    if (!activeCard) {



      return null;



    }







    return activeCard.dataset.aihmLocation;



  }











  /* -------------------------------------------------------



     Initialize clinic content



     ------------------------------------------------------- */







  function initAIHMClinicContent() {







    const sections =



      document.querySelectorAll(



        '[data-aihm-clinic-content]'

      );



    if (!sections.length) {

      return;

    }


    const selectedLocation =

      currentAIHMLocation ||

      getSelectedAIHMLocation();

    if (selectedLocation) {

      showAIHMClinic(

        selectedLocation

      );


      return;

    }


    /*

     * Fallback:

     * use first clinic only when no carousel

     * selection exists.

     */




    sections.forEach(function (section) {

      const firstPanel =

        section.querySelector(

          '[data-aihm-clinic]'

        );


      if (!firstPanel) {

        return;

      }


      const location =

        firstPanel.dataset.aihmClinic;

      if (location) {

        showAIHMClinic(location);

      }

    });


  }



  /* -------------------------------------------------------

     Appointment button preparation

     Modal will be connected in next phase

     ------------------------------------------------------- */


  document.addEventListener(

    'click',

    function (event) {

      const button =

        event.target.closest(

          '[data-aihm-book-appointment]'

        );

      if (!button) {

        return;

      }


      const clinicName =

        button.dataset.aihmClinicName || '';

      const locationName =

        button.dataset.aihmLocationName || '';

      document.dispatchEvent(

        new CustomEvent(

          'aihm:appointment-open',

          {

            detail: {

              clinicName: clinicName,

              locationName: locationName

            }

          }

        )

      );

    }

  );


  /* -------------------------------------------------------

     Normal page load

     ------------------------------------------------------- */


  if (document.readyState === 'loading') {

    document.addEventListener(

      'DOMContentLoaded',

      initAIHMClinicContent

    );


  } else {


    initAIHMClinicContent();

  }




  /* -------------------------------------------------------

     Shopify Theme Editor

     ------------------------------------------------------- */



  document.addEventListener(
  
    'shopify:section:load',

    function () {



      window.setTimeout(



        initAIHMClinicContent,

        50

      );

    }

  );


})();


/* =============== AIHM CLINIC CONTENT Connect Location Carousel with Clinic Content END ========= */

/* =========================================================

   AIHM FULLSCREEN CLINIC GALLERY LIGHTBOX

\========================================================= */

(function(){'use strict';let box=null,stageImg=null,counter=null,items=[],index=0,touchX=null;

function ensure(){if(box)return;box=document.createElement('div');box.className='aihm-gallery-lightbox';box.setAttribute('aria-hidden','true');box.innerHTML='\<button class="aihm-gallery-lightbox__close" type="button" aria-label="Close gallery">×\</button>\<button class="aihm-gallery-lightbox__prev" type="button" aria-label="Previous photo">‹\</button>\<div class="aihm-gallery-lightbox__stage">\<img class="aihm-gallery-lightbox__image" alt="">\<div class="aihm-gallery-lightbox__counter">\</div>\</div>\<button class="aihm-gallery-lightbox__next" type="button" aria-label="Next photo">›\</button>';document.body.appendChild(box);stageImg=box.querySelector('.aihm-gallery-lightbox__image');counter=box.querySelector('.aihm-gallery-lightbox__counter');box.querySelector('.aihm-gallery-lightbox__close').addEventListener('click',close);box.querySelector('.aihm-gallery-lightbox__prev').addEventListener('click',function(){show(index-1)});box.querySelector('.aihm-gallery-lightbox__next').addEventListener('click',function(){show(index+1)});box.addEventListener('click',function(e){if(e.target===box)close()});box.addEventListener('touchstart',function(e){touchX=e.changedTouches[0].clientX},{passive:true});box.addEventListener('touchend',function(e){if(touchX===null)return;const dx=e.changedTouches[0].clientX-touchX;if(Math.abs(dx)>45)show(index+(dx<0?1:-1));touchX=null},{passive:true});}

function collect(key){const data=document.querySelector('[data-aihm-gallery-data="'+CSS.escape(key)+'"]');if(!data)return[];return Array.from(data.querySelectorAll('[data-aihm-gallery-image]')).map(function(el){return{src:el.dataset.src,alt:el.dataset.alt||''}}).filter(function(x){return x.src})}

function show(i){if(!items.length)return;index=(i+items.length)%items.length;stageImg.src=items[index].src;stageImg.alt=items[index].alt;counter.textContent=(index+1)+' / '+items.length}

function open(key,start){ensure();items=collect(key);if(!items.length)return;box.classList.add('is-open');box.setAttribute('aria-hidden','false');document.body.classList.add('aihm-lightbox-open');show(Number(start)||0)}

function close(){if(!box)return;box.classList.remove('is-open');box.setAttribute('aria-hidden','true');document.body.classList.remove('aihm-lightbox-open');if(stageImg)stageImg.src=''}

document.addEventListener('click',function(e){const trigger=e.target.closest('[data-aihm-gallery-open]');if(!trigger)return;e.preventDefault();open(trigger.dataset.aihmGallery,trigger.dataset.aihmGalleryIndex)});document.addEventListener('keydown',function(e){if(!box||!box.classList.contains('is-open'))return;if(e.key==='Escape')close();if(e.key==='ArrowLeft')show(index-1);if(e.key==='ArrowRight')show(index+1)});

})();



/* =============== AIHM FULLSCREEN CLINIC GALLERY END =============== */



 



/* =========================================================

   AIHM APPOINTMENT FORM EMAIL SUBMISSION

   ========================================================= */



(function () {

  'use strict';



  function initAIHMAppointmentEmail() {
    const form = document.getElementById('AIHMAppointmentForm');
    if (!form || form.dataset.emailReady === 'true') return;

    form.dataset.emailReady = 'true';
    const success = form.querySelector('[data-aihm-form-success]');
    const errorBox = form.querySelector('[data-aihm-form-error]');
    const submitButton = form.querySelector('.aihm-appointment-form__submit');
    const submitText = submitButton ? submitButton.querySelector('span') : null;
    const originalText = submitText ? submitText.textContent : 'Book Appointment';

    if (success) success.hidden = true;

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (success) success.hidden = true;
      if (errorBox) errorBox.hidden = true;
      if (submitButton) submitButton.disabled = true;
      if (submitText) submitText.textContent = 'Submitting...';

      try {
        const data = Object.fromEntries(new FormData(form));
        data._subject = 'New AIHM Clinic Appointment Request';
        data._template = 'table';
        data._captcha = 'false';

        const response = await fetch('https://formsubmit.co/ajax/thehakimsuleman@gmail.com', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(data)
        });

        // FormSubmit can return success as a boolean or a string.
        const result = await response.json();
        const accepted = result &&
          (result.success === true || String(result.success).toLowerCase() === 'true');

        if (!response.ok || !accepted) {
          throw new Error(result && result.message ? result.message :
            'FormSubmit did not confirm the submission.');
        }

        // Google Sheet: send the same confirmed appointment before redirecting.
        // This does not alter the existing FormSubmit email flow.
        try {
          const sheetPayload = new URLSearchParams({
            full_name: data['contact[name]'] || '',
            phone: data['contact[phone]'] || '',
            appointment_date: data['contact[Preferred Date]'] || '',
            city: data['contact[City]'] || '',
            state: data['contact[State]'] || '',
            problem: data['contact[Health Concern]'] || '',
            problem_duration: data['contact[Problem Duration]'] || '',
            clinic_visit: data['contact[Wants Clinic Visit]'] || '',
            preferred_clinic: data['contact[Preferred Clinic]'] || '',
            page_url: window.location.href
          });
          const sheetController = new AbortController();
          const sheetTimeout = setTimeout(function () { sheetController.abort(); }, 8000);
          try {
            await fetch('https://script.google.com/macros/s/AKfycbyGDOQHw5HL2_3usmQwST4XhEhdfoxa3TvhRkx5XDkg5Oa2H_lHi7aX8WqVM5plpzgi/exec', {
              method: 'POST',
              mode: 'no-cors',
              body: sheetPayload,
              signal: sheetController.signal
            });
          } finally {
            clearTimeout(sheetTimeout);
          }
        } catch (sheetError) {
          // Sheet availability must not interrupt the existing thank-you flow.
          console.error('AIHM Google Sheet request:', sheetError);
        }

        window.location.assign('https://atiyaherbs.com/pages/appointment-thank-you');
      } catch (error) {
        console.error('AIHM appointment submission:', error);
        if (errorBox) {
          errorBox.textContent = 'Something went wrong. Please try again.';
          errorBox.hidden = false;
        }
        if (submitButton) submitButton.disabled = false;
        if (submitText) submitText.textContent = originalText;
      }
    });
  }

  if (document.readyState === 'loading') {

    document.addEventListener(

      'DOMContentLoaded',

      initAIHMAppointmentEmail

    );

  } else {

    initAIHMAppointmentEmail();

  }



  document.addEventListener(

    'shopify:section:load',

    function () {

      setTimeout(initAIHMAppointmentEmail, 100);

    }

  );



})();


